import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useFrontendContext, ApiRequestStatus, frontendActions, Themes } from '@cmctechnology/webinvest-store-frontend';
import { ApiRequest, CLIENT_STORE_NAME, clientActions } from '@cmctechnology/webinvest-store-client';
import { getThemeConfig } from '@cmctechnology/webinvest-constants';
import { useSelector } from 'react-redux';
import { IStore } from '../store/store';
import { AU_LOGIN_PATH, SPLASH_SCREEN_PROPS } from '../constants/constants';
import { SplashScreenZoomDisabledWrapper } from '../components/SplashScreenZoomDisabledWrapper';

const SEPARATOR = '__';

export const Logout: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signoutRequested, setSignoutRequested] = useState(false);
  const { theme, publicUrl } = useFrontendContext();

  /* istanbul ignore next */
  const status = useSelector((store: IStore) => store.frontend.apiResults[`${CLIENT_STORE_NAME}${SEPARATOR}${ApiRequest.SignOut}`]?.status);

  useEffect(() => {
    dispatch<any>(clientActions.signOut());
    setSignoutRequested(true);
  }, []);

  useEffect(() => {
    if (!signoutRequested) return;
    if (status === ApiRequestStatus.Success || status === ApiRequestStatus.Failed) {
      dispatch<any>(frontendActions.apiRequestReset(ApiRequest.SignOut));
      // navigating to /{region}/login, instead of assigning redirect route.
      // redirecting to /dashboard is handled in the webinvest-module-login-fg.
      // after login success, will redirect to /dashboard.
      // integrated/changed this as per SBCI-1803.
      // const redirectUrl = searchParams.get(`redirect_url`);
      // const redirectQuery = redirectUrl ? `?redirect_url=${encodeURIComponent(redirectUrl)}` : ``;
      // navigate(`${publicUrl}/sg/login${redirectQuery}`);

      const regionPath =
        theme && theme === Themes.ASB
          ? `/${getThemeConfig(theme).themePath}/login/start`
          : // eslint-disable-next-line unicorn/no-nested-ternary
            theme
            ? `/${getThemeConfig(theme).themePath}/login`
            : AU_LOGIN_PATH;
      sessionStorage.clear();
      navigate(`${publicUrl}${regionPath}`);
      navigate(0);
    }
  }, [status, signoutRequested]);

  return <SplashScreenZoomDisabledWrapper {...SPLASH_SCREEN_PROPS} />;
};
